export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6430.1b642713.jpg";